import { render } from "./edit.vue?vue&type=template&id=eef2d4d0&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=eef2d4d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eef2d4d0"

export default script